// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Override$LiteracyplanetClientFlags from "./Override.res.mjs";
import * as ContextMaker$LiteracyplanetClientFlags from "./ContextMaker.res.mjs";

var Api = {
  name: "SystemFlagsContext"
};

var include = ContextMaker$LiteracyplanetClientFlags.Make(Api);

var Provider = include.Provider;

var use = include.use;

var Context_initialContext = include.initialContext;

var Context_context = include.context;

var Context_P = include.P;

var Context_ContextMakerProviderNotFound = include.ContextMakerProviderNotFound;

var Context = {
  Api: Api,
  initialContext: Context_initialContext,
  context: Context_context,
  P: Context_P,
  Provider: Provider,
  ContextMakerProviderNotFound: Context_ContextMakerProviderNotFound,
  use: use
};

function SystemFlags$Provider(props) {
  var match = React.useState(function (param) {
        return Override$LiteracyplanetClientFlags.loadFlags();
      });
  var setSystemFlags = match[1];
  var setSystemFlag = function (key, bool) {
    Override$LiteracyplanetClientFlags.saveFlag(key, bool);
    Curry._1(setSystemFlags, (function (param) {
            return Override$LiteracyplanetClientFlags.loadFlags();
          }));
  };
  return React.createElement(Provider.make, {
              value: {
                systemFlags: match[0],
                setSystemFlag: setSystemFlag
              },
              children: props.children
            });
}

var Provider$1 = {
  make: SystemFlags$Provider
};

export {
  Context ,
  Provider$1 as Provider,
  use ,
}
/* include Not a pure module */
